import React from 'react';
import { ContentPage } from 'modules2/content-page';
import { SearchCard } from './components';
import container from './Search.container';

const Search = (props) => {
  const {
    searchPodcastState: { query, results }
  } = props;
  const searchResult = results.length ? ` (${results.length})` : '';
  return (
    <ContentPage
      header={{
        title: `Search`,
        description: `${query ? query + searchResult : ''}`,
        controls: ''
      }}
      body={<SearchCard />}
    />
  );
};

export default container(Search);
